/**
 * Translate description: Filter component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';

export default () => {
  const { t } = useLanguageContext();
  const { filter, setFilter, setPaginator } = useContext(AppContext);
  return (
    <Fragment>
      <FormControl size="sm">
        <FormLabel>{t('Source')}</FormLabel>
        <Select
          size="sm"
          placeholder={t('Filter by source')}
          slotProps={{
            button: { sx: { whiteSpace: 'nowrap' } },
            listbox: { placement: 'bottom-end' },
          }}
          onChange={(e, v) => {
            if (!e) return;
            setFilter({ ...filter, source: v })
            setPaginator({ currentPage: 1 });
          }}
          defaultValue=""
        >
          <Option value={"all"}>{t('All')}</Option>
          <Option value={"ext"}>{t('Only extention')}</Option>
          <Option value={"shark"}>{t('Only catcher')}</Option>
        </Select>
      </FormControl>
    </Fragment>
  )
};
